if (!customElements.get('pickup-availability')) {
  customElements.define(
    'pickup-availability',
    class PickupAvailability extends HTMLElement {
      constructor() {
        super();

        if (!this.hasAttribute('available')) return;

        this.errorHtml = this.querySelector('template').content.firstElementChild.cloneNode(true);
        this.onClickRefreshList = this.onClickRefreshList.bind(this);
        this.fetchAvailability(this.dataset.variantId);
      }

      fetchAvailability(variantId) {
        if (!variantId) return;

        let rootUrl = this.dataset.rootUrl;
        if (!rootUrl.endsWith('/')) {
          rootUrl = rootUrl + '/';
        }
        const variantSectionUrl = `${rootUrl}variants/${variantId}/?section_id=pickup-availability`;

        fetch(variantSectionUrl)
          .then((response) => response.text())
          .then((text) => {
            const sectionInnerHTML = new DOMParser()
              .parseFromString(text, 'text/html')
              .querySelector('.shopify-section');
            this.renderPreview(sectionInnerHTML);
          })
          .catch((e) => {
            const button = this.querySelector('button');
            if (button) button.removeEventListener('click', this.onClickRefreshList);
            this.renderError();
          });
      }

      onClickRefreshList() {
        this.fetchAvailability(this.dataset.variantId);
      }

      update(variant) {
        if (variant?.available) {
          this.fetchAvailability(variant.id);
        } else {
          this.removeAttribute('available');
          this.innerHTML = '';
        }
      }

      renderError() {
        this.innerHTML = '';
        this.appendChild(this.errorHtml);

        const refreshButton = this.querySelector('button');
        if (refreshButton) {
          refreshButton.type = 'button';
          refreshButton.addEventListener('click', (evt) => {
            evt.preventDefault();
            evt.stopPropagation();
            this.onClickRefreshList();
          });
        }
      }

      bindPickupButton(button) {
        if (!button) return;
        button.type = 'button';
        button.addEventListener('click', (evt) => {
          evt.preventDefault();
          evt.stopPropagation();
          document.querySelector('pickup-availability-drawer')?.show(evt.currentTarget);
        });
      }

      renderPreview(sectionInnerHTML) {
        const drawer = document.querySelector('pickup-availability-drawer');
        if (drawer) drawer.remove();
        if (!sectionInnerHTML.querySelector('pickup-availability-preview')) {
          this.innerHTML = '';
          this.removeAttribute('available');
          return;
        }

        this.innerHTML = sectionInnerHTML.querySelector('pickup-availability-preview').outerHTML;
        this.setAttribute('available', '');

        const pickupDrawer = sectionInnerHTML.querySelector('pickup-availability-drawer');
        document.body.appendChild(pickupDrawer);

        this.bindPickupButton(this.querySelector('button'));
      }
    }
  );
}

if (!customElements.get('pickup-availability-drawer')) {
  customElements.define(
    'pickup-availability-drawer',
    class PickupAvailabilityDrawer extends HTMLElement {
      constructor() {
        super();

        this.onBodyClick = this.handleBodyClick.bind(this);
        this.modalContent = this.querySelector('.product-details-wrapper-inside');
        this.closeButton = this.querySelector('.drawer-icon-close');

        if (this.closeButton) {
          this.closeButton.addEventListener('click', () => {
            this.hide();
          });
        }

        this.addEventListener('keyup', (event) => {
          if (event.code.toUpperCase() === 'ESCAPE') this.hide();
        });
      }

      handleBodyClick(evt) {
        if (this.modalContent && !this.modalContent.contains(evt.target)) {
          this.hide();
        }
      }

      hide() {
        this.style.visibility = 'hidden';
        this.removeAttribute('open');
        document.body.removeEventListener('click', this.onBodyClick);
        document.body.classList.remove('overflow-hidden');
        if (typeof removeTrapFocus === 'function') {
          removeTrapFocus(this.focusElement);
        }
      }

      show(focusElement) {
        this.focusElement = focusElement;
        this.style.visibility = 'visible';
        this.setAttribute('open', '');
        document.body.addEventListener('click', this.onBodyClick);
        document.body.classList.add('overflow-hidden');
        if (typeof trapFocus === 'function') {
          trapFocus(this);
        }
      }
    }
  );
}
